import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { razorPay } from "../../types";

const razorPayState: razorPay.razorPayStateType = {
  razorPayIdDetails: {
    data: undefined,
    isLoading: false,
    errors: "",
  },
};

export const razorPaySlice = createSlice({
  name: "razorPay",
  initialState: razorPayState,
  reducers: {
    //Razor pay order Id
    razorPayOrderIdRequest: (
      state: razorPay.razorPayStateType,
      action: PayloadAction<any>
    ) => {
      state.razorPayIdDetails.isLoading = true;
      state.razorPayIdDetails.errors = "";
    },
    razorPayOrderIdSuccess: (
      state: razorPay.razorPayStateType,
      action: PayloadAction<any>
    ) => {
      state.razorPayIdDetails.isLoading = false;
      state.razorPayIdDetails.data = action.payload?.data;
    },
    razorPayOrderIdError: (
      state: razorPay.razorPayStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.razorPayIdDetails.isLoading = false;
      state.razorPayIdDetails.errors = error;
    },
  },
});

export const {
  razorPayOrderIdRequest,
  razorPayOrderIdSuccess,
  razorPayOrderIdError,
} = razorPaySlice.actions;

export default razorPaySlice.reducer;
